import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { StartRenewalSummaryResponse } from '@responses/renewal-summary';
import axios from 'axios';

/**
 * Starts a Summary of Changes job for a renewal. The server answers 202 with
 * the new job, 409 when a job is already in flight, 429 when the daily AI
 * budget is spent and 400 when the submission is not a renewal.
 */
export const startRenewalSummary = async (renewalId: string): Promise<StartRenewalSummaryResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'post',
    url: `/submissions/${renewalId}/renewal_summary`,
    data: {},
  });
  const response = await axios<StartRenewalSummaryResponse>(networkPayload);
  return response.data;
};
